import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from "../../../common-items/services/helper.service";

@Component({
  selector: 'app-login-errors',
  templateUrl: './login-errors.component.html',
  styleUrls: ['./login-errors.component.less']
})
export class LoginErrorsComponent implements OnInit {

  sessionStatus: string = "";
  title: string = "";
  message: string = "";
  errorCode: any;
  constructor(private router: Router , public helperService : HelperService) {}

  ngOnInit() {
    let link = "";
    this.errorCode = sessionStorage.getItem("ErrorCode") 
    if(this.errorCode){
      this.sessionStatus = this.helperService.checkErrorMessage(this.errorCode);
    }
    link = window.location.href;
    
    switch(this.sessionStatus) { 
      default: { 
        this.title = "Error";
        this.message = "Something has gone wrong. Please try logging in again from <a href='"+link+"' (click)='clearSession()'>here</a>." ;
        sessionStorage.clear();
        break;              
      } 
    }
  }

  clearSession(){
    sessionStorage.clear();
  }
  
}
